<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <n-button @click="$router.push({name: 'documents.create'})">Добавить документ</n-button>
      </n-divide>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #content="{item}">
          <div style="max-height: 300px; overflow: hidden; text-overflow: ellipsis;" v-html="item.content"></div>
        </template>
        <template #file="{item}">
          <a :href="item.file" target="_blank">Скачать</a>
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'documents.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'title', title: 'Название', },
      { name: 'content', title: 'Описание', },
      { name: 'file', title: 'Файл', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.documents.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 350px;
    --n-image-height: 150px;
  }
</style>
